import { assetTypeTranslations } from '@sh4res/bo-common/i18n/en/asset_types';
import { b2bTranslations } from '@sh4res/bo-common/i18n/en/b2b';
import { instrumentsTranslations } from '@sh4res/bo-common/i18n/en/instruments';
import { usersTranslations } from '@sh4res/bo-common/i18n/en/users';

export const enTranslationsBoCommon = {
  bo_common: {
    actions: {
      next: 'Next',
      back: 'Back',
      continue_later: 'Continue later',
      save_draft: {
        success: 'Draft saved',
        failure: 'Failed to save: %{error}',
        errors: {
          campaigns: {
            overlap_campaign_fiscal_period:
              'Overlapping campaign already exists for this type, company and fiscal period',
            overlap_campaign_consultation_period:
              'Overlapping campaign already exists for this type and company, and consultation period',
          },
        },
      },
      type_to_search: 'Start typing to search',
      drop_file: 'Drop your file here',
    },
    export: {
      failure: 'Export failed: %{error}',
      without_filter: {
        title: 'Export the whole list?',
        content:
          'No filter is applied: the whole list will be exported. This export can be very large, take a long time and put a significant load on the system. Consider applying filters first (e.g. the creation date range). Do you want to export the whole list anyway?',
      },
    },
    version: {
      new_available: 'New version available',
      cta: 'Refresh',
    },
    filters: {
      search_placeholder: 'Search filters',
      no_match: 'No filter matches “%{query}”',
    },
    profile_popup: {
      role: 'Role',
      language: 'Language',
      settings: 'Settings',
      start_tour: 'Start product tour',
    },
    ...instrumentsTranslations,
    users: usersTranslations,
    b2b: b2bTranslations,
    asset_types: assetTypeTranslations,
    file_upload: {
      error: 'Error on file : %{error}',
      password_protected: 'The file provided is password protected, please provide another file.',
    },
    all_documents: {
      list_modal: {
        title: 'Documents',
        download: 'Download',
        no_preview: 'File can not be previewed',
      },
      edit_modal: {
        title: 'Edit document',
      },
      no_permission: 'You do not have permission to view this document',
      actions: { edit: { success: 'Edit Successful', failure: 'saving %{error}' } },
    },
    year: 'Year',
    validation: {
      invalid_international_phone_number_format:
        'Number must start with + and country code (e.g., +33...)',
      invalid_international_phone_number: 'Invalid international phone number',
      invalid_mobile_phone_number: 'Must be a mobile phone number',
      invalid_date: 'Please enter a valid date between the years 1900 and 9999',
      url_invalid: 'Please enter a valid URL including the protocol (e.g., https://)',
      iban: {
        checksum_not_number: 'Checksum is not a number',
        no_iban_country: 'Could not get country code from IBAN',
        no_iban_provided: 'Not an IBAN',
        qriban_not_allowed: 'QR-IBAN is not allowed',
        wrong_bban_format: 'Wrong BBAN format',
        wrong_bban_length: 'Wrong BBAN length',
        wrong_iban_checksum: 'Wrong IBAN checksum',
        format: 'Invalid IBAN format',
      },
      bic: {
        checksum_not_number: 'Not a BIC',
        no_bic_country: 'Could not get country code from BIC',
        wrong_bic_format: 'Wrong BIC format',
      },
    },
    services_page: {
      title: 'Services',
      savings_coach: {
        title: 'Savings Coach',
        description:
          'The Savings Coach service is a personalized support service for employees, allowing them to benefit from a telephone appointment with a specialized financial advisor, in order to be guided in their investment decisions within their employee savings or retirement plan',
      },
      robot_advisor: {
        title: 'Robot Advisor',
        description:
          "The Robot Advisor is a module integrated into the platform that allows an Employee to be guided in their investment or savings management choices. It is based on a dynamic questionnaire whose responses make it possible to recommend one or more target allocations based on the user's profile, investment horizon, savings objectives and preferences.",
      },
    },
    accessibility: {
      back: 'Back',
      clear: 'Clear',
      close: 'Close',
      copy_id: 'Copy ID',
      copied: 'Copied to clipboard',
      delete: 'Delete',
      toggle: 'Toggle',
      stepper: {
        ariaLabel: '%{label}, step %{current} of %{total}%{suffix}',
        currentSuffix: ', current step',
      },
      sorted_ascending: 'Sorted by %{field} ascending',
      sorted_descending: 'Sorted by %{field} descending',
    },
    meta: {
      page: '%{title} - Page %{page}',
    },
    yes: 'Yes',
    no: 'No',
  },
};
